import _ from 'lodash';
import queryString from 'query-string';
import React, { memo } from 'react';
import createClass from 'create-react-class';
import ContentLoader from 'react-content-loader';

import { Select, MenuItem, Button } from '@mui/material';
import {Trans, withTranslation } from 'react-i18next';
import { RTL, SUPPORTED_LANGUAGES, HOTEL_INFO_FIELDS } from 'arbitrip-common/translation/const';

import ResultsStore from '../../../stores/ResultsStore';
import HotelStore from '../../../stores/HotelStore';
import BasketStore from '../../../stores/BasketStore';
import ProfileStore from '../../../stores/ProfileStore';
import FiltersStore from '../../../stores/FiltersStore';
import SearchStore from '../../../stores/SearchStore';
import PointsStore from '../../../stores/PointsStore';
import PointsConstants from '../../../constants/PointsConstants';

import HotelActions from '../../../actions/HotelActions';
import SearchActions from '../../../actions/SearchActions';
import PointsActions from '../../../actions/PointsActions';
import FilterActions from '@/actions/FiltersActions';

import HotelConstants from '../../../constants/HotelConstants';
import { getHotelTabsLabels } from './hotelInfo/constants.js';
import DealConstants from '../../../constants/DealConstants';
import ExpiredResultsConstants from '../../../components/general/expired-results/constants';

import RoomsCatalog from './RoomsCatalog.react';
import RoomsCatalogDialog from './RoomsCatalogDialog.react';
import { ReactComponent as SortIcon } from '@/img/icons/sort.svg';

import DealsStatisticsSection from './DealsStatisticsSection.react';
import Stars from '@/components/general/Stars';
import HotelAddress from '../hotel/HotelAddressComponent.react';
import NoAvailabilityMessage from '../hotel/NoAvailabilityMessage.react';
import HotelMapBox from '../results/filters/HotelMapBox.react';
import DealComponent from '../results/deal/DealComponent.react';
import TripDetails from './TripDetails.react';
import HotelTabs from './hotelInfo/HotelTabs.react.js';
import HotelReview from './HotelReview.react';
import HotelReasons from './HotelReasons.react';
import ExpiredResultsComponent from '../../general/expired-results/ExpiredResultsComponent.react';
import FilterDealsSection from './FilterDealsSection.react';
import DealsTitle from './DealsTitle.react';
import BnplTopBanner from '../reservation-payment/components/BnplTopBanner.react';

import { Link } from 'react-router-dom';

import HotelImagesCollage from './HotelImagesCollage.react';
import TitleManager from '../../../utils/TitleManager';
import RouterWrapper from '../../../utils/RouterWrapper';
import Ajax from '../../../utils/Ajax';
import Validator from 'arbitrip-common/client/utils/Validator';
import memoizeOne from 'arbitrip-common/client/utils/memoizeOne';
import SearchTermsParser from '../../../utils/SearchTermsParser';

import DealUtils from '../../../entities/DealUtils';

import Analytics from 'arbitrip-common/client/analytics';
import { getPointsToggleState } from 'arbitrip-common/client/analytics/services/loyaltyService';
import Config from 'arbitrip-common/client/utils/Config';
import {
    isDealAboveBnplMinimum,
    isBnplChargeDateEligible,
} from 'arbitrip-common/client/utils/BnplUtils';
import DocumentTitle from '../../general/DocumentTitle.react';
import DealLoader from './DealLoader';
import PointsToggleComponent from '../results/PointsToggleComponent.react';
import { isElalCompany } from '@/utils/isCompany';
import LazyRecheckStore from '../../../stores/LazyRecheckStore';
import LazyRecheckLoader from './LazyRecheckLoader.react';
import LazyRecheckActions from '../../../actions/LazyRecheckActions';
import TermsChangedDialog from '../reservation-payment/components/TermsChangedDialog.react';
import { getAvailablePointsBudget } from 'arbitrip-common/client/utils/PointsRecheckSplit';
import DealUnavailableDialog from '../reservation-payment/components/DealUnavailableDialog.react';
import RecheckAlternative, { RECHECK_TYPE } from 'arbitrip-common/client/utils/RecheckAlternative';
import DealActions from '../../../actions/DealActions';
import InstallmentsBanner from '../../InstallmentsBanner.react';

const FROM_LOGIN_PARAM = 'from_login';
const USE_MAX_POINTS_PARAM = 'use_max_points';

const { EXPIRED_TYPES } = ExpiredResultsConstants;

const _busy_recheck_display_timeout_in_seconds = process.env.REACT_APP_FIREBASE_RECHECK_TIMEOUT_IN_SECONDS || 30;
const BUSY_RECHECK_DISPLAY_TIMEOUT_IN_MILLISECONDS = _busy_recheck_display_timeout_in_seconds * 1000;

const _search_threshold_in_seconds = process.env.REACT_APP_HOTEL_SEARCH_RECHECK_DELAY_IN_SECONDS || 10;
const SEARCH_THRESHOLD_IN_MILLISECONDS = _search_threshold_in_seconds * 1000;

const DEAL_LOADERS_COUNT_DEFAULT = 5;
const DEAL_LOADERS_COUNT = 2;

const SORT_OPTIONS = {
	PRICE: 'PRICE',
	CANCELLATION_DATE: 'CANCELLATION_DATE',
};

function sortDeals(deals, sortBy) {
	if (!deals || deals.length === 0) {
		return [];
	}

	switch (sortBy) {
		case SORT_OPTIONS.PRICE:
			return _.sortBy(deals, 'totalPrice');

		case SORT_OPTIONS.CANCELLATION_DATE:
			return deals.sort((a, b) => {
				const dateA = new Date(_.get(a, 'chooseprod.dca.dealIsFullyRefundableTill', 0)).getTime();
				const dateB = new Date(_.get(b, 'chooseprod.dca.dealIsFullyRefundableTill', 0)).getTime();

				if (dateA !== dateB) {
					// later dealIsFullyRefundableTill date first
					return dateB - dateA;
				}

				// if dates are equal, sort by totalPrice
				const priceA = _.get(a, 'totalPrice', Infinity);
				const priceB = _.get(b, 'totalPrice', Infinity);

				// lower price first
				return priceA - priceB;
			});

		default:
			return deals;
	}
}

function getHotelPageState(hotel_id) {
	const profile = ProfileStore.getProfile();

	let contract_client_company_id = SearchStore.getContractClientCompanyId();
	if (!contract_client_company_id && profile.agent) {
		contract_client_company_id = ProfileStore.getSelfContractCompanyId();
	}

	return {
		hotel_info: HotelStore.getHotelById(hotel_id),
		hotel: ResultsStore.getHotelById(hotel_id),
		got_results: ResultsStore.didReturnMultipleResults(),
		mapBoxData: FiltersStore.getMapBoxData(),
		hotelDeals: _.sortBy(ResultsStore.getHotelIndexedDealsById(hotel_id), 'totalPrice'),
		hotel_pre_pay_deals: ResultsStore.getHotelIndexedPrePayDealsById(hotel_id),
		hotel_post_pay_deals: ResultsStore.getHotelIndexedPostPayDealsById(hotel_id),
		hotel_half_board_deals: ResultsStore.getHotelIndexedHalfBoardDealsById(hotel_id),
		hotel_all_inclusive_deals: ResultsStore.getHotelIndexedAllInclusiveDealsById(hotel_id),
		info_status: ResultsStore.getHotelInfoStatusById(hotel_id),
		deals_status: ResultsStore.getHotelDealsStatusById(hotel_id),
		recheck_status: ResultsStore.getHotelRecheckStatusById(hotel_id),
		deals_cached_status: ResultsStore.getHotelDealsCachedStatusById(hotel_id),
		travel_policy: ResultsStore.getTravelPolicy(),
		search_terms: SearchStore.getSearchTerms(),
		search_token: SearchStore.getToken(),
		deals_filter: FiltersStore.getDealsFilterData(),
		banned_deal_ids: ResultsStore.getBannedDealIds(),
		basket: BasketStore.getBasket(),
		profile,
		recheck_timestamp: ResultsStore.getRecheckTimestamp(hotel_id),
		show_recheck_loader: true,
		arbitrip_points_applied: ResultsStore.areArbitripPointsApplied(),
		search_session: ResultsStore.getCurrentSearchSession(),
		contract_client_company_id,
	};
}

// Trailing args are unused cache-key inputs, not computation inputs. The Flux stores mutate
// `hotel`/`hotel_info` in place (stable references), so memoizeOne can't detect changes by reference
// alone — passing info_status/deals_status/recheck_timestamp/lastTranslateDurationMs forces a recompute
// when info/deals/recheck advance or translation enrichment completes.
function computeHotel(hotel, hotel_info, _info_status, _deals_status, _recheck_timestamp, _lastTranslateDurationMs) {
	return _.merge({}, hotel, hotel_info, _.pick(hotel, ['distanceInKm', 'distanceDescription', 'deals']));
}

const MemoizedHotelMapBox = memo(({ hotel, mapBoxData, search_terms }) => {
	if (!hotel || !window.google) {
		return null;
	}
	return (
		<div className="hotel-map-box-container" id="hotel-map-box" data-testid="hotel-map-box">
			<HotelMapBox
				mapBoxData={mapBoxData}
				mode="hotel"
				hotel={hotel}
				searchTerms={search_terms}
			/>
		</div>
	);
});

const HotelPage = createClass({
	displayName: 'HotelPage',

	getInitialState: function () {
		const { t } = this.props;

		this._getHotelMemoized = memoizeOne(computeHotel);

		const hotelPageState = getHotelPageState(this.props.hotelId);

		if (hotelPageState.deals_status !== HotelConstants.DEALS_STATUS.SUCCESS) {
			hotelPageState.deals_status = HotelConstants.DEALS_STATUS.INITIAL;
		}
		if (hotelPageState.recheck_status !== HotelConstants.RECHECK_STATUS.SUCCESS) {
			hotelPageState.recheck_status = HotelConstants.RECHECK_STATUS.INITIAL;
		}
		hotelPageState.max_deals_to_show = this.getMaxDeals(hotelPageState);
		hotelPageState.show_superseded_deals = false;
		hotelPageState.dynamicPriceIdFilter = '';
        hotelPageState.supersededFilter = '';
        hotelPageState.hide_expedia_deals = false;
        hotelPageState.show_only_expedia_deals = false;

        hotelPageState.showRoomDialog = false;
        hotelPageState.roomDialogData = null;
        hotelPageState.roomDialogName = null;
        hotelPageState.roomDialogAnalyticsFunc = null;
        hotelPageState.activeTab = getHotelTabsLabels(t).DESCRIPTION;
        hotelPageState.reviewScoreClickCounter = 0;
        hotelPageState.reservation_manipulation = {
            is_fail_init: false,
            is_fail_recheck: false,
            increase_price: '',
        };
        hotelPageState.sortBy = SORT_OPTIONS.PRICE;
        hotelPageState.showOriginal = false;
        hotelPageState.showOriginalPolicies = false;
        hotelPageState.lastTranslateDurationMs = 0;

        hotelPageState.translateLoading = false;

        hotelPageState.lazy_recheck_busy = false;
        hotelPageState.lazy_recheck_price_change_data = null;
        hotelPageState.lazy_recheck_no_availability = false;
        hotelPageState.lazy_recheck_dialog_open = false;

        return hotelPageState;
    },

	onTogglePolicies() {
		this.setState((s) => ({ showOriginalPolicies: !s.showOriginalPolicies }));
	},

    componentDidUpdate: function (prevProps, prevState) {
        let hotel_id = this.props.hotelId;
        let search_params = queryString.parse(this.props.location.search);
        let search_token = search_params.search_token;
        // let previous_cached_fail = prevState.deals_cached_status === HotelConstants.DEALS_STATUS.FAIL;
        // let current_cached_fail = this.state.deals_cached_status === HotelConstants.DEALS_STATUS.FAIL;
        let previous_cached_fail = prevState.recheck_status === HotelConstants.RECHECK_STATUS.FAIL;
        let current_cached_fail = this.state.recheck_status === HotelConstants.RECHECK_STATUS.FAIL;
        const _self = this;

        if (
            !this.state.requested_hotels &&
            Validator.validateSearchToken(search_token, SearchStore.getSignedParams()) &&
            !previous_cached_fail &&
            current_cached_fail
        ) {
            setTimeout(() => {
                HotelActions.getHotelDeals(hotel_id);
                _self.setState({ requested_hotels: true });
            }, 11); // VERY BAD PRACTICE
        }

        if (!prevState.recheck_timestamp && this.state.recheck_timestamp) {
            const recheck_duration_in_milliseconds = Date.now() - this.state.recheck_timestamp;
            if (recheck_duration_in_milliseconds < BUSY_RECHECK_DISPLAY_TIMEOUT_IN_MILLISECONDS) {
                this.setState({ show_recheck_loader: true });
                if (this.recheck_loader_timeout) {
                    clearTimeout(this.recheck_loader_timeout);
                }
                this.recheck_loader_timeout = setTimeout(() => {
                    _self.setState({
                        show_recheck_loader: false,
                    });
                }, BUSY_RECHECK_DISPLAY_TIMEOUT_IN_MILLISECONDS - recheck_duration_in_milliseconds);
            }
        }

        if (
            (prevState.recheck_status === HotelConstants.RECHECK_STATUS.INITIAL ||
                prevState.recheck_status === HotelConstants.RECHECK_STATUS.BUSY) &&
            (this.state.recheck_status === HotelConstants.RECHECK_STATUS.SUCCESS ||
                this.state.recheck_status === HotelConstants.RECHECK_STATUS.FAIL)
        ) {
            if (this.recheck_loader_timeout) {
                clearTimeout(this.recheck_loader_timeout);
                this.recheck_loader_timeout = null;
            }
            this.setState({ show_recheck_loader: false });
        }

        if (prevState.hotelDeals.length !== this.state.hotelDeals.length) {
            const visibleDeals = [
                ...this.getRepresentativeDeal(),
                ...this.getPrePayDeals(),
                ...this.getPostPayDeals(),
            ].map(({ props }) => props.deal);
            HotelActions.setTotalDisplayedDealsCount(visibleDeals.length);
            HotelActions.setDisplayedDMetrics({
                hotel_id: hotel_id,
                d_metrics: visibleDeals?.map((d) => d?.d_metrics),
            });
        }

        if (prevState.recheck_status !== this.state.recheck_status) {
            if (
                this.state.recheck_status !== HotelConstants.RECHECK_STATUS.INITIAL &&
                this.state.recheck_status !== HotelConstants.RECHECK_STATUS.BUSY &&
                this.getValidDealsCount(this.state.hotelDeals) === 0
            ) {
                Analytics.actions.responses.searchWithoutResultsHotel(this.state.profile, this.state.hotel, this.state.search_terms);
            }
        }

        if (prevProps.hotelId !== this.props.hotelId) {
			this._analyticsViewFired = false;
		}

		if (isElalCompany() && !this._analyticsViewFired && PointsStore.getStatus() === PointsConstants.STATUS.SUCCESS) {
			const { profile, search_terms } = this.state;
			const hotel = this.getHotel();
			if (hotel?.id === this.props.hotelId) {
				Analytics.actions.views.hotelPage(profile, hotel, search_terms, undefined, undefined, {
					arrived_from_login: this._arrivedFromLogin,
					points_toggle_state: this._pointsToggleState,
				});
				this._analyticsViewFired = true;
			}
		}
    },

    componentDidMount: function () {
        ////////////////////////////////////////////////////////////////////////////////
        // componentWillMount
        ////////////////////////////////////////////////////////////////////////////////
		const params = new URLSearchParams(window.location.search);
		this._arrivedFromLogin = params.get(FROM_LOGIN_PARAM) === '1';
		this._pointsToggleState = getPointsToggleState(params.get(USE_MAX_POINTS_PARAM) === 'true');

		if (params.has(FROM_LOGIN_PARAM)) {
			params.delete(FROM_LOGIN_PARAM);
			const search = params.toString();
			const newUrl = `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`;
			window.history.replaceState(window.history.state, '', newUrl);
		}

        const { navigate, location, hotelId } = this.props;
        const { profile, search_terms } = this.state;
        const hotel = this.getHotel();
        const search_params = queryString.parse(location.search);
        const { search_token } = search_params;
        const hotel_id = _.get(hotel, 'id', hotelId);

        if (!Validator.validateObjectId(hotel_id)) {
            return RouterWrapper.goToSearchPage(navigate);
        }

        if (!_.get(hotel, 'hotelInfo')) {
            setTimeout(() => {
                HotelActions.getHotelInfo(hotel_id);
            });
        }

        let skip_recheck = this.state.recheck_status === HotelConstants.RECHECK_STATUS.SUCCESS;

        if (!skip_recheck && Validator.validateSearchToken(search_token, SearchStore.getSignedParams())) {
            const ml = ResultsStore.getTimePassedSinceSearchSessionCreatedInMilliSeconds();
            const timeout = hotel.shallow || ml < 0 ? 0 : Math.max(SEARCH_THRESHOLD_IN_MILLISECONDS - ml, 0);

            setTimeout(() => {
                if (hotel.shallow) {
                    HotelActions.getHotelDeals(hotel_id);
                } else {
                    HotelActions.getHotelRecheckedDeals(hotel_id, search_token);
                }
            }, timeout);
            this.setState({ requested_hotels: true });

            this.recheck_loader_timeout = setTimeout(() => {
                this.setState({
                    show_recheck_loader: false,
                });
            }, BUSY_RECHECK_DISPLAY_TIMEOUT_IN_MILLISECONDS * 2);
        } else if (!skip_recheck && this.validateSearchParams(search_params)) {
            setTimeout(() => {
                HotelActions.getHotelDeals(hotel_id);
            });
            this.setState({ requested_hotels: true });

            this.recheck_loader_timeout = setTimeout(() => {
                this.setState({
                    show_recheck_loader: false,
                });
            }, BUSY_RECHECK_DISPLAY_TIMEOUT_IN_MILLISECONDS * 2);
        } else {
            this.setState({ info_only: true });
        }

        window.scrollTo(0, 0);

        this._analyticsViewFired = false;

		if (hotel) {
			if (!isElalCompany()) {
				Analytics.actions.views.hotelPage(profile, hotel, search_terms, undefined, undefined, {
					arrived_from_login: this._arrivedFromLogin,
					points_toggle_state: this._pointsToggleState,
				});
			} else if (PointsStore.getStatus() === PointsConstants.STATUS.SUCCESS) {
				Analytics.actions.views.hotelPage(profile, hotel, search_terms, undefined, undefined, {
					arrived_from_login: this._arrivedFromLogin,
					points_toggle_state: this._pointsToggleState,
				});
				this._analyticsViewFired = true;
			}
        } else {
            console.warn('hotel page mounted with no hotel in state... skipped analytics view hotel page action');
        }

        HotelStore.addChangeListener(this._onChange);
        ResultsStore.addChangeListener(this._onChange);
        FiltersStore.addChangeListener(this._onChange);
        BasketStore.addChangeListener(this._onChange);
        ProfileStore.addChangeListener(this._onChange);
        PointsStore.addChangeListener(this._onPointsChange);
        LazyRecheckStore.addChangeListener(this._onLazyRecheckChange);

        // Trigger translation check for the default active tab on mount
        // Ensures loader reflects the actual in-flight translation request (if any)
        setTimeout(() => {
            this.handleTabChange(this.state.activeTab);
        }, 0);
    },

    getMaxDeals(state) {
        const { hotelDeals } = state;
        let counter = 0;
        if (hotelDeals) {
            for (const key in hotelDeals) {
                const deal = hotelDeals[key];
                if (deal.status && deal.status !== 'initial') {
                    counter++;
                }
            }
        }

        return Math.max(HotelConstants.MAX_DEALS_TO_SHOW, counter);
    },

    validateSearchParams: function (search_params) {
        if (!search_params) {
            return false;
        }

        let { check_in, check_out, rooms, guests } = search_params;

        if (!SearchTermsParser.validateDates(check_in, check_out)) {
            return false;
        }

        if (!SearchTermsParser.validateRooms(rooms)) {
            return false;
        }

        if (!SearchTermsParser.validateRooms(guests)) {
            return false;
        }

        return true;
    },

    componentWillUnmount: function () {
        if (this.recheck_loader_timeout) {
            clearTimeout(this.recheck_loader_timeout);
        }

        HotelStore.removeChangeListener(this._onChange);
        ResultsStore.removeChangeListener(this._onChange);
        FiltersStore.removeChangeListener(this._onChange);
        BasketStore.removeChangeListener(this._onChange);
        ProfileStore.removeChangeListener(this._onChange);
        LazyRecheckStore.removeChangeListener(this._onLazyRecheckChange);
        PointsStore.removeChangeListener(this._onPointsChange);
        LazyRecheckActions.reset();
    },

    showRoomDialog(room, name, analyticsFunc) {
        this.setState({
            showRoomDialog: true,
            roomDialogData: room,
            roomDialogName: name,
            roomDialogAnalyticsFunc: analyticsFunc,
        });
    },

    onCloseRoomDialog() {
        this.setState({ showRoomDialog: false });
    },

	onRoomsCatalogOpen(room) {
		this.showRoomDialog(room, null, Analytics.actions.views.roomInfoDialogSidemenu);
	},

    handleSortByChange: function (event) {
        const newSortBy = event.target.value;
        const { deals_filter, freeCancellationManuallySet } = this.state;

        let updatedDealsFilter = { ...deals_filter };

        if (newSortBy === SORT_OPTIONS.CANCELLATION_DATE) {
            if (!deals_filter.free_cancellation_only) {
                updatedDealsFilter.free_cancellation_only = true;
                FilterActions.filterDealsByCancellationOnly(true);
            }
        } else if (newSortBy === SORT_OPTIONS.PRICE) {
            if (deals_filter.free_cancellation_only && !freeCancellationManuallySet) {
                updatedDealsFilter.free_cancellation_only = false;
                FilterActions.filterDealsByCancellationOnly(false);
            }
        }

        this.setState({
            sortBy: newSortBy,
            deals_filter: updatedDealsFilter,
        });
    },

    doesDealPassFilters: function (deal) {
        let any_filter =
            this.state.deals_filter.breakfast_only ||
            this.state.deals_filter.half_board_only ||
            this.state.deals_filter.all_inclusive_only ||
            this.state.deals_filter.post_pay_only ||
            this.state.deals_filter.bnpl_only ||
            this.state.deals_filter.negotiated_rate_only ||
            this.state.deals_filter.free_cancellation_only ||
            this.state.deals_filter.in_policy_only;
        if (!any_filter) {
            return true;
        }
        if (deal.status === DealConstants.DEAL_STATUS.FAIL || deal.status === DealConstants.DEAL_STATUS.NA) {
            return false;
        }
        if (this.state.deals_filter.breakfast_only && !deal.breakfast) {
            return false;
        }
        if (this.state.deals_filter.post_pay_only && !deal.post_pay) {
            return false;
        }
        if (this.state.deals_filter.bnpl_only) {
			const nonRefundable = _.get(deal, 'chooseprod.dca.nonRefundable', true);
			const cancellationDate = _.get(deal, 'chooseprod.dca.dealIsFullyRefundableTill');
			if (nonRefundable || !cancellationDate) {
				return false;
			}
			const settings = _.get(this.state, 'profile.company.settings');
			if (!isBnplChargeDateEligible(cancellationDate, settings)) {
				return false;
			}
			if (!isDealAboveBnplMinimum(deal, settings)) {
				return false;
			}
		}
        if (this.state.deals_filter.negotiated_rate_only && !deal.negotiated_rate) {
            return false;
        }
        if (this.state.deals_filter.free_cancellation_only && deal.chooseprod && deal.chooseprod.dca.nonRefundable) {
            return false;
        }
        if (this.state.deals_filter.in_policy_only && !deal.in_policy) {
            return false;
        }
        if (
            this.state.deals_filter.half_board_only &&
            this.state.deals_filter.all_inclusive_only &&
            (_.get(deal, 'board_bases.half_board') ||
                _.get(deal, 'board_bases.full_board') ||
                _.get(deal, 'board_bases.all_inclusive'))
        ) {
            return true;
        } else if (this.state.deals_filter.half_board_only && !_.get(deal, 'board_bases.half_board')) {
            return false;
        } else if (
            this.state.deals_filter.all_inclusive_only &&
            !(_.get(deal, 'board_bases.full_board') || _.get(deal, 'board_bases.all_inclusive'))
        ) {
            return false;
        }
        return true;
    },

    showDeal: function (deal) {
        if (!deal) {
            return false;
        }
        if (deal.not_available) {
            return false;
        }
        if (deal.ignore) {
            return false;
        }
        if (deal.superseded && !this.state.show_superseded_deals) {
            return false;
        }

        if (this.state.hide_expedia_deals && deal.id && deal.id.startsWith('E:')) {
            return false;
        }

        if (this.state.show_only_expedia_deals && deal.id && !deal.id.startsWith('E:')) {
            return false;
        }

        if (this.state.dynamicPriceIdFilter) {
            return deal.dynamicPricing?.dynamic_pricing_group_id?.includes(this.state.dynamicPriceIdFilter);
        }

        if (this.state.supersededFilter) {
            return deal?.superseded_group_id?.includes(this.state.supersededFilter);
        }

        return this.doesDealPassFilters(deal);
    },

    showSupersededDeals: function () {
        this.setState({
            show_superseded_deals: !this.state.show_superseded_deals,
        });
    },

    onFilterByDynamicPriceId: function (event) {
        this.setState({
            dynamicPriceIdFilter: event.target.value,
        });
    },

    onSupersededFilter: function (event) {
        this.setState({
            supersededFilter: event.target.value,
        });
    },

	onBnplLearnMore: function () {
		document.getElementById('hotel-deals-list')?.scrollIntoView({ behavior: 'smooth' });
	},

	onFreeCancellationToggle: function (value) {
		this.setState({ freeCancellationManuallySet: value });
	},

	onReservationManipulationInitChange: function (e) {
		const checked = e.target.checked;
		this.setState((s) => ({
			reservation_manipulation: { ...s.reservation_manipulation, is_fail_init: checked },
		}));
	},

	onReservationManipulationRecheckChange: function (e) {
		const checked = e.target.checked;
		this.setState((s) => ({
			reservation_manipulation: { ...s.reservation_manipulation, is_fail_recheck: checked },
		}));
	},

	onReservationManipulationPriceChange: function (e) {
		const value = e.target.value;
		this.setState((s) => ({
			reservation_manipulation: { ...s.reservation_manipulation, increase_price: value },
		}));
	},

    getValidDealsCount: function (hotelDeals) {
        let valid_deals = Object.values(hotelDeals).filter(DealUtils.isValidDeal);
        const filter_superseded = !this.state.show_superseded_deals;
        if (filter_superseded) {
            valid_deals = valid_deals.filter((d) => !d.superseded);
        }
        return valid_deals.length;
    },

    getDealComponents(deals, options = {}) {
        const { showRepresentativeDeal = true, bestRate = false, startingIndex = 0 } = options;
        const {
            hotel,
            basket,
            info_status,
            max_deals_to_show,
            show_superseded_deals,
            profile,
            arbitrip_points_applied,
            reservation_manipulation,
        } = this.state;

        const _hotel = this.getHotel();

        let index = startingIndex + 1;
        let DEALS_COMPONENTS = [];

        if (_.isObject(deals)) {
            deals.forEach((deal) => {
                const deal_id = deal.id;
                if (
                    (showRepresentativeDeal || deal_id !== this._representativeDealId) &&
                    this.showDeal(deal) &&
                    DEALS_COMPONENTS.length < max_deals_to_show
                ) {
                    DEALS_COMPONENTS.push(
                        <DealComponent
                            key={deal_id}
                            deal={deal}
                            index={index}
                            displayed_deal_order_count={index++}
                            hotel={_hotel}
                            basket={basket}
                            add_to_list_disabled={info_status === HotelConstants.INFO_STATUS.BUSY}
                            representative={this._representativeDealId && deal_id === this._representativeDealId}
                            show_superseded_deals={show_superseded_deals}
                            showRoomDialog={this.showRoomDialog}
                            bestRate={bestRate}
                            profile={profile}
                            arbitripPointsApplied={arbitrip_points_applied}
                            contractClientCompanyId={this.state.contract_client_company_id}
                            searchTerms={this.state.search_terms}
                            roomDetailsClickHandler={this.showRoomDialog}
                            reservationManipulation={reservation_manipulation}
                        />,
                    );
                }
            });
        }

        return DEALS_COMPONENTS;
    },

    getRepresentativeDeal() {
        const { sortBy, banned_deal_ids, hotel, hotelDeals } = this.state;

        let deal;

        if (sortBy === SORT_OPTIONS.CANCELLATION_DATE) {
            if (!hotelDeals?.length) return [];
            // when sorting by cancellation date, pick the deal with the latest refundable deadline
            const sortedByDeadline = sortDeals(hotelDeals, SORT_OPTIONS.CANCELLATION_DATE);
            deal = sortedByDeadline[0];
        } else {
            // otherwise, use the default representative deal (typically the cheapest)
            deal = _.get(hotel, 'representativeDeal');
        }

        if (!deal) return [];

        if (banned_deal_ids.includes(deal.id)) {
            deal.not_available = true;
            deal.status = DealConstants.DEAL_STATUS.NA;
        }

        this._representativeDealId = deal.id;
        return this.getDealComponents([deal], { bestRate: true, startingIndex: 0 });
    },

    getPrePayDeals() {
        let { hotel_pre_pay_deals, sortBy } = this.state;

        if (!hotel_pre_pay_deals) {
            return [];
        }

        const filtered = hotel_pre_pay_deals.filter((d) => d.id !== this._representativeDealId);

        const sortedDeals = sortDeals(filtered, sortBy);

        let countByRoomGroup = _.countBy(sortedDeals, 'room_group');
        let groupByRoomGroup = _.groupBy(sortedDeals, 'room_group');

        for (let room_group in groupByRoomGroup) {
            for (let deal of groupByRoomGroup[room_group]) {
                if (deal) {
                    deal.room_group_description = deal.room_group_description || '';
                    deal.room_group_count = countByRoomGroup[deal.room_group];
                }
            }
        }

        const indexStart = this.getRepresentativeDeal().length;

        return this.getDealComponents(sortedDeals, { showRepresentativeDeal: false, startingIndex: indexStart });
    },

    getPostPayDeals() {
        let { hotel_post_pay_deals, sortBy } = this.state;

        if (!hotel_post_pay_deals) return [];

        const filtered = hotel_post_pay_deals.filter((d) => d.id !== this._representativeDealId);

        const sortedDeals = sortDeals(filtered, sortBy);

        let countByRoomGroup = _.countBy(sortedDeals, 'room_group');
        let groupByRoomGroup = _.groupBy(sortedDeals, 'room_group');

        for (let room_group in groupByRoomGroup) {
            for (let deal of groupByRoomGroup[room_group]) {
                if (deal) {
                    deal.room_group_description = deal.room_group_description || '';
                    deal.room_group_count = countByRoomGroup[deal.room_group];
                }
            }
        }

        const indexStart = this.getRepresentativeDeal().length + this.getPrePayDeals().length;

        return this.getDealComponents(sortedDeals, { showRepresentativeDeal: false, startingIndex: indexStart });
    },

    getDealsPlaceholderRender(valid_deals_count) {
        const { t } = this.props;
        const results_route = RouterWrapper.buildResultsRoute(this.state.search_terms, this.state.search_token);

		if (
			this.state.recheck_status !== HotelConstants.RECHECK_STATUS.INITIAL &&
			this.state.recheck_status !== HotelConstants.RECHECK_STATUS.BUSY &&
			valid_deals_count === 0
		) {
			return (
				<div className="no-valid-deals-wrapper">
					<img
						className="empty-state-image"
						src="../../img/recent_searches/recent_searches_empty.svg"
						alt="no results"
					></img>
					<div>{t('NoAvailabilityOnTheseDates')}</div>
					<div>
						{t('TryChangeDates')} <Link to={results_route}>{t('SelectDifferentHotel')}</Link>
					</div>
				</div>
			);
		}
	},

    getHotelOrHotelInfoPropertyByKey(key) {
        const { hotel_info, hotel } = this.state;

        return (
            _.get(hotel, `hotelInfo.${key}`) ||
            _.get(hotel, key) ||
            _.get(hotel_info, `hotelInfo.${key}`) ||
            _.get(hotel_info, key)
        );
    },

    toggleOriginal() {
        this.setState({ showOriginal: !this.state.showOriginal });
    },

    getTranslationKeysForTab(label) {
        const { t } = this.props;
        const HOTEL_TABS_LABELS = getHotelTabsLabels(t);
        if (label === HOTEL_TABS_LABELS.DESCRIPTION) return [HOTEL_INFO_FIELDS.ABOUT];
        if (label === HOTEL_TABS_LABELS.AMENITIES) return [HOTEL_INFO_FIELDS.AMENITIES];
        if (label === HOTEL_TABS_LABELS.POLICIES)
            return [HOTEL_INFO_FIELDS.SUPPLIER_TERMS, HOTEL_INFO_FIELDS.EXTRA_INFORMATION];
        return [];
    },

    handleTabChange(label) {
        const { profile } = this.state;
        const hotel = this.getHotel();
        const hotelId = _.get(hotel, 'id', this.props.hotelId);
        // reset per-tab original/translation toggle when leaving the previous tab
        this.setState({ showOriginal: false });
        // reset duration meta by default; will be set after a real translation call completes
        this.setState({ lastTranslateDurationMs: 0 });
        const keys = this.getTranslationKeysForTab(label);
        if (keys.length) {
            const lang = this.props?.i18n?.language;
            const enableHotelInfoTranslation = _.get(profile, 'company.settings.enable_hotel_info_translation', false);

            if (!enableHotelInfoTranslation) {
                this.setState({ translateLoading: false, lastTranslateDurationMs: 0 });
                return;
            }

            const isTranslatedForKey = (key) => {
                const translations = this.getHotelOrHotelInfoPropertyByKey(`${key}_translations`) || {};
                const val = translations?.[lang];
                return Array.isArray(val) ? val.length > 0 : !!val;
            };
            const missingKeys =
                lang && lang !== SUPPORTED_LANGUAGES.EN ? keys.filter((k) => !isTranslatedForKey(k)) : [];

			if (missingKeys.length === 0) {
				// Nothing to translate; ensure loader is off
				this.setState({ translateLoading: false, lastTranslateDurationMs: 0 });
			} else {
				const startedAt = Date.now();
				this.setState({ translateLoading: true });
				Ajax.translateHotelFields(hotelId, missingKeys)
					.done((translated) => {
						translated.hotel_id = hotelId;
						HotelActions.enrichHotelWithAdditionalInfo(translated);
						this.setState({
							translateLoading: false,
							lastTranslateDurationMs: Date.now() - startedAt,
						});
					})
					.fail((err) => {
						console.error(err);
						this.setState({
							translateLoading: false,
							lastTranslateDurationMs: Date.now() - startedAt,
						});
					});
			}
		}
	},

	getHotel() {
		const { hotel_info, hotel, info_status, deals_status, recheck_timestamp, lastTranslateDurationMs } = this.state;

		return this._getHotelMemoized(hotel, hotel_info, info_status, deals_status, recheck_timestamp, lastTranslateDurationMs);
	},

    getDebugMode() {
        return Config.dev_mode || (Config.prod && this.state.profile.is_arbi_support);
    },

    getBackToResultsRender() {
        const { search_token, search_terms, got_results } = this.state;
        const { t } = this.props;
        if (!SearchTermsParser.validate(search_terms)) return null;

        const linkContent = got_results ? (
            <span>{t('BackToResults')}</span>
        ) : (
            <span onClick={this.seeOtherHotels}>{t('SeeOtherHotels')}</span>
        );

        return (
            <div className="back-to-results">
                <Link to={RouterWrapper.buildResultsRoute(search_terms, got_results ? search_token : null)}>
                    <img src={'/img/back_icon.svg'} alt={t('BackButton')} />
                    {linkContent}
                </Link>
            </div>
        );
    },

	seeOtherHotels() {
		SearchActions.search();
		RouterWrapper.goToResultsPage(this.props.navigate, this.state.search_terms);
	},

    onReviewScoreClick() {
        const { t } = this.props;

        this.setState(
            (prevState) => ({
                activeTab: getHotelTabsLabels(t).REVIEWS,
                reviewScoreClickCounter: prevState.reviewScoreClickCounter + 1,
            }),
            () => {
                setTimeout(this.scrollToTabs, 0);
            },
        );
    },
    viewDealsScrollHandler() {
        if (this.filtersAndDealsEl) {
            const top = this.filtersAndDealsEl.getBoundingClientRect().top + window.scrollY;
            window.scrollTo({ top: top - 100, behavior: 'smooth' });
        }
    },
    scrollToTabs() {
        const tabsWrapper = document.querySelector('.tabs-wrapper');
        if (tabsWrapper) {
            window.Velocity(tabsWrapper, 'scroll', {
                duration: 1250,
                easing: 'ease-in-out',
                offset: -74, // top bar height
            });
        }
    },

    hasFreeCancellationDeals() {
        return this.state.hotelDeals.some((deal) => deal.chooseprod?.dca?.dealIsFullyRefundableTill);
    },

    render() {
        const {
            profile,
            hotelDeals,
            hotel_post_pay_deals,
            hotel_half_board_deals,
            hotel_all_inclusive_deals,
            search_session,
            search_terms,
        } = this.state;

        const { t, i18n } = this.props;
        const isRtl = i18n.dir() === RTL;

        const _hotel = this.getHotel();

        if (_.isEmpty(_hotel)) {
            console.log("Hotel page couldn't be rendered");
            return <div className="hotel-page"></div>;
        }

        const display_debug = this.getDebugMode();
        // here is the place where we can hide rooms catalog
        const isShowRoomCatalog = true;

		const any_deals_filter =
			this.state.deals_filter.in_policy_only ||
			this.state.deals_filter.free_cancellation_only ||
			this.state.deals_filter.breakfast_only ||
			this.state.deals_filter.post_pay_only ||
			this.state.deals_filter.bnpl_only ||
			this.state.deals_filter.negotiated_rate_only;
		const deals_loading = this.state.recheck_status
			? this.state.recheck_status === HotelConstants.RECHECK_STATUS.BUSY ||
				this.state.recheck_status === HotelConstants.RECHECK_STATUS.INITIAL
			: true;

        const REPRESENTATIVE_DEAL = this.getRepresentativeDeal();
        const PRE_PAY_DEALS = this.getPrePayDeals();
        const POST_PAY_DEALS = this.getPostPayDeals();
        const ALL_DEALS = PRE_PAY_DEALS.concat(POST_PAY_DEALS, REPRESENTATIVE_DEAL);
        const multipleKindOfDealsExist = !!(PRE_PAY_DEALS.length && POST_PAY_DEALS.length);

        const num_hotel_deals = _.size(hotelDeals);

		const post_pay_deals_exists = _.size(hotel_post_pay_deals) > 0;
		const half_board_deals_exists = _.size(hotel_half_board_deals) > 0;
		const all_inclusive_deals_exists = _.size(hotel_all_inclusive_deals) > 0;
		const bnpl_deals_exists =
			(_.get(this.state, 'profile.settings.bnpl_enabled', false) ||
				_.get(this.state, 'profile.company.settings.bnpl_enabled', false)) &&
			(this.state.hotelDeals || []).some((deal) => {
				const nonRefundable = _.get(deal, 'chooseprod.dca.nonRefundable', true);
				const cancellationDate = _.get(deal, 'chooseprod.dca.dealIsFullyRefundableTill');
				if (nonRefundable || !cancellationDate) return false;
				const settings = _.get(this.state, 'profile.company.settings');
				if (!isBnplChargeDateEligible(cancellationDate, settings)) return false;
				return isDealAboveBnplMinimum(deal, settings);
			});

        let valid_deals_count = 0;
        if (typeof hotelDeals === 'object') {
            valid_deals_count += this.getValidDealsCount(hotelDeals);
        }

        let loadersCount = 0;
        if (deals_loading) {
            loadersCount =
                valid_deals_count < DEAL_LOADERS_COUNT_DEFAULT
                    ? DEAL_LOADERS_COUNT_DEFAULT - valid_deals_count
                    : DEAL_LOADERS_COUNT;
        }

        const INFO_SPINNER = !_hotel &&
            this.state.info_status === HotelConstants.INFO_STATUS.BUSY &&
            Array.isArray(_hotel.images) &&
            _hotel.images.length > 0 && (
                <div className="info-status-container">
                    <i className="fa fa-spinner fa-spin" />
                </div>
            );

        const title = TitleManager.buildTitleStartsWith(_.get(_hotel, 'name', ''), true, true);

        return (
            <DocumentTitle title={title}>
                <div className="hotel-page" data-testid="hotel-details">
                    {this.getBackToResultsRender()}
                    <div className="hotel-container top-container">
                        <div className="hotel-main">
                            {_hotel.images?.length > 0 && <HotelImagesCollage images={_hotel.images} />}

                            <Stars stars={_hotel.stars} hide={_hotel.stars_hide} />

                            <div className="hotel-name"> {_hotel.name} </div>

                            <HotelAddress
                                hotel={_hotel}
                                showDistance={true}
                                showAlternativeDistance={true}
                                forceAddress={true}
                            />

                            {INFO_SPINNER}

							<MemoizedHotelMapBox
								hotel={_hotel}
								mapBoxData={this.state.mapBoxData}
								search_terms={this.state.search_terms}
							/>

							{display_debug && (
								<DealsStatisticsSection
									hotelDeals={this.state.hotelDeals}
									reservationManipulation={this.state.reservation_manipulation}
									profile={this.state.profile}
									displayDebugging={display_debug}
									dynamicPriceIdFilter={this.state.dynamicPriceIdFilter}
									onShowSupersededDeals={this.showSupersededDeals}
									onFilterByDynamicPriceId={this.onFilterByDynamicPriceId}
									onInitStatusChange={this.onReservationManipulationInitChange}
									onRecheckChange={this.onReservationManipulationRecheckChange}
									onPriceChange={this.onReservationManipulationPriceChange}
								/>
							)}
						</div>
						<div className="hotel-side">
							<TripDetails hotel={_hotel} searchTerms={search_terms} />
							<div className="review-reasons-container">
								<HotelReview hotel={_hotel} onReviewScoreClick={this.onReviewScoreClick} />
								{!isRtl && <HotelReasons hotel={_hotel} />}
							</div>
							<div className="view-deals-container">
								<Button className="view-deals-button" onClick={this.viewDealsScrollHandler} >
									{t('ViewDeals')}
								</Button>
							</div>
						</div>
					</div>
					<div className="hotel-container">
						<div className="hotel-main" style={{ paddingTop: '28px' }}>
							{bnpl_deals_exists && (
								<div className="hotel-page__bnpl-section">
									<BnplTopBanner
										learnMoreText={t('HotelPage.BnplViewDeals')}
										onLearnMore={() =>
											document
												.getElementById('hotel-deals-list')
												?.scrollIntoView({ behavior: 'smooth' })
										}
									/>
									<InstallmentsBanner isLoading={deals_loading && num_hotel_deals === 0} isRtl={isRtl} text={
										<Trans
										i18nKey="HotelPage.BnplInstalmentsBannerVariant2"
										values={{ installments_max_num:3 }}
										components={{
											strong: <strong />,
										}}
									/>} />
								</div>
							)}
                            <div
                                ref={(el) => (this.filtersAndDealsEl = el)}
                                className="filters-and-deals"
                                data-testid="choose-your-room-section"
                                id="hotel-deals-list"
                            >
                                <div className="title-wrapper">
                                    <div className="title">{t('ChooseYourRoom')}</div>
                                    <PointsToggleComponent withTooltip/>
                                </div>
								<FilterDealsSection
									numHotelDeals={num_hotel_deals}
									postPayDealsExists={post_pay_deals_exists}
									halfBoardDealsExists={half_board_deals_exists}
									allInclusiveDealsExists={all_inclusive_deals_exists}
									bnplDealsExists={bnpl_deals_exists}
									travelPolicy={this.state.travel_policy}
									isRtl={isRtl}
									dealsLoading={deals_loading}
									onFreeCancellationToggle={this.onFreeCancellationToggle}
								/>

                                {num_hotel_deals > 0 && (
                                    <div className="sort-by-wrapper">
                                        <SortIcon />
                                        <label htmlFor="sort-by-select">{t('Sort.Label')}</label>
                                        <Select
                                            id="sort-by-select"
                                            value={this.state.sortBy}
                                            onChange={this.handleSortByChange}
                                            variant="outlined"
                                            disabled={!this.hasFreeCancellationDeals()}
                                            inputProps={{
                                                'data-testid': 'room-sort-dropdown',
                                            }}
                                        >
                                            <MenuItem value={SORT_OPTIONS.PRICE}>{t('Sort.Options.Price')}</MenuItem>
                                            <MenuItem value={SORT_OPTIONS.CANCELLATION_DATE}>
                                                {t('Sort.Options.CancellationDate')}
                                            </MenuItem>
                                        </Select>
                                    </div>
                                )}

								

                                {deals_loading && num_hotel_deals === 0 && (
                                    <div className="deals-group-loader">
                                        <ContentLoader width="100%" height="18" viewBox="0 0 768 18" rtl={isRtl}>
                                            <rect x="0" y="0" rx="10" ry="10" width="89" height="18" />
                                        </ContentLoader>
                                    </div>
                                )}

                                {this.state.info_only ? null : this.getDealsPlaceholderRender(valid_deals_count)}

                                {ALL_DEALS.length === 0 && any_deals_filter && valid_deals_count > 0 && (
                                    <NoAvailabilityMessage />
                                )}

                                {multipleKindOfDealsExist ? (
                                    <>
                                        {REPRESENTATIVE_DEAL.length > 0 && (
                                            <DealsTitle title={t('BestRate')}>{REPRESENTATIVE_DEAL}</DealsTitle>
                                        )}

                                        {PRE_PAY_DEALS.length > 0 && (
                                            <DealsTitle title={t('PrePayRates')}>{PRE_PAY_DEALS}</DealsTitle>
                                        )}

                                        {POST_PAY_DEALS.length > 0 && (
                                            <DealsTitle title={t('PostPayRates')}>{POST_PAY_DEALS}</DealsTitle>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        {REPRESENTATIVE_DEAL}
                                        {PRE_PAY_DEALS}
                                        {POST_PAY_DEALS}
                                    </>
                                )}

                                {Array.from({ length: loadersCount }).map((_, i) => (
                                    <DealLoader key={`loader-${i}`} isRtl={isRtl} />
                                ))}
                            </div>

							<div className="tabs-wrapper">
								<HotelTabs
									key={this.state.reviewScoreClickCounter}
									activeTab={this.state.activeTab}
									loading={this.state.translateLoading}
									onTabChange={this.handleTabChange}
									hotel={_hotel}
									getHotelOrHotelInfoPropertyByKey={this.getHotelOrHotelInfoPropertyByKey}
									durationMs={this.state.lastTranslateDurationMs}
									showOriginalPolicies={this.state.showOriginalPolicies}
									onTogglePolicies={this.onTogglePolicies}
								/>
							</div>
						</div>
						<div className="hotel-side" data-testid="rooms-right-sidebar">
							{isShowRoomCatalog && _hotel.rooms && (
								<div className="catalog">
									<RoomsCatalog
										onOpen={(room) =>
											this.showRoomDialog(
												room,
												null,
												Analytics.actions.views.roomInfoDialogSidemenu,
											)
										}
										hotel={_hotel}
										profile={profile}
										searchSession={search_session}
										rooms={_hotel.rooms}
									/>
								</div>
							)}
						</div>
					</div>
					<ExpiredResultsComponent
						type={EXPIRED_TYPES.BACK_TO_RESULTS}
						expiredEntityText="deals"
						hotelId={this.props.hotelId}
						hotelName={this.props.hotelName}
					/>
					<RoomsCatalogDialog
						open={this.state.showRoomDialog}
						onClose={this.onCloseRoomDialog}
						room={this.state.roomDialogData}
						roomName={this.state.roomDialogName}
						analyticsFunc={this.state.roomDialogAnalyticsFunc}
						isDev={display_debug}
						hotel={_hotel}
						profile={profile}
                    />
                    
                    <LazyRecheckLoader visible={this.state.lazy_recheck_busy} />

                    {this.state.lazy_recheck_dialog_open && !this.state.lazy_recheck_no_availability && (() => {
                        const pcd = this.state.lazy_recheck_price_change_data;
                        const best_deal = pcd ? pcd.best_deal : null;
                        const points = isElalCompany() ? PointsStore.getPoints() : null;
                        const shows_prices_with_points =
                            ResultsStore.getShowPricesInPoints() && !!points?.show && points?.balance > 0;
                        return (
                            <TermsChangedDialog
                                modalIsOpen={this.state.lazy_recheck_dialog_open}
                                oldPrice={pcd ? pcd.old_price : null}
                                newPrice={pcd ? pcd.new_price : null}
                                priceChanged={!!pcd?.price_changed}
                                oldCancellationDeadline={pcd ? pcd.old_cancellation_deadline : null}
                                newCancellationDeadline={pcd ? pcd.new_cancellation_deadline : null}
                                deadlineChanged={!!pcd?.deadline_changed}
                                boardChanged={!!pcd?.board_changed}
                                oldBoard={pcd ? pcd.old_board : null}
                                newBoard={pcd ? pcd.new_board : null}
                                deal={best_deal}
                                roomName={RecheckAlternative.getRoomName(LazyRecheckStore.getClickedDeal())}
                                nights={best_deal ? best_deal.nights : undefined}
                                rooms={best_deal ? best_deal.rooms : undefined}
                                showUnchangedTerms={true}
                                points={points}
                                pointsBudget={shows_prices_with_points ? getAvailablePointsBudget(points) : 0}
                                profile={profile}
                                onConfirm={this._onLazyRecheckConfirmPriceChange}
                                onBack={this._onLazyRecheckBack}
                            />
                        );
                    })()}
                    {this.state.lazy_recheck_dialog_open && this.state.lazy_recheck_no_availability && (
                        <DealUnavailableDialog
                            modalIsOpen={this.state.lazy_recheck_dialog_open}
                            roomName={RecheckAlternative.getRoomName(LazyRecheckStore.getClickedDeal())}
                            onBack={this._onLazyRecheckBack}
                        />
                    )}
				</div>
			</DocumentTitle>
		);
	},

    _maybeFetchElalAnonPointsRate: function (profile) {
		if (isElalCompany() && profile && profile.anonymous && !profile.isLoggedIn && !this._elalAnonRateFetched) {
			this._elalAnonRateFetched = true;
			PointsActions.getElalAnonPointsRate();
		}
	},

    // Method to setState based upon Store changes
    _onChange: function () {
        const nextState = getHotelPageState(this.props.hotelId);
        this.setState(nextState);
        this._maybeFetchElalAnonPointsRate(nextState.profile);
    },

    _onPointsChange: function () {
		if (!isElalCompany() || this._analyticsViewFired) {
			return;
		}
		if (PointsStore.getStatus() !== PointsConstants.STATUS.SUCCESS) {
			return;
		}
		const { profile, search_terms } = this.state;
		const hotel = this.getHotel();
		if (hotel?.id) {
			Analytics.actions.views.hotelPage(profile, hotel, search_terms, undefined, undefined, {
				arrived_from_login: this._arrivedFromLogin,
				points_toggle_state: this._pointsToggleState,
			});
			this._analyticsViewFired = true;
		}
	},

    _onLazyRecheckChange: function () {
        const navigation_deal = LazyRecheckStore.getNavigationDeal();
        const price_change_data = LazyRecheckStore.getPriceChangeData();
        const no_availability = LazyRecheckStore.isNoAvailability();
        const busy = LazyRecheckStore.isBusy();
        const is_expired = LazyRecheckStore.isExpired();

        if (is_expired) {
            this.setState({
                isShowExpiredError: true,
            });
            setTimeout(() => LazyRecheckActions.reset(), 0);
            return;
        }

        if (navigation_deal && !price_change_data) {
            setTimeout(() => {
                DealActions.chooseDeal(navigation_deal);
                LazyRecheckActions.reset();
                RouterWrapper.goToReservationPage(this.props.navigate);
            }, 0);
            return;
        }

        const dialog_will_open = !!(price_change_data || no_availability);
        if (dialog_will_open && !this.state.lazy_recheck_dialog_open) {
            if (no_availability) {
                const rejected_comparison = LazyRecheckStore.getRejectedComparison();
                const clicked_deal = LazyRecheckStore.getClickedDeal();
                this._rateCheckPopupCount = Analytics.actions.responses.roomRateCheckPopupShown({
                    popup_type: 'rate_unavailable',
                    recheck_type: RECHECK_TYPE.LAZY,
                    unavailable_reason: LazyRecheckStore.getUnavailableReason(),
                    rejection_reason: rejected_comparison?.rejection_reason ?? null,
                    price_changed: !!rejected_comparison?.price_changed,
                    ...RecheckAlternative.buildOriginalTerms(clicked_deal),
                    new_price: rejected_comparison?.new_price ?? null,
                    deadline_changed: !!rejected_comparison?.deadline_changed,
                    board_changed: !!rejected_comparison?.board_changed,
                    new_board: rejected_comparison?.new_board ?? null,
                    new_cancellation_deadline: rejected_comparison?.new_cancellation_deadline ?? null,
                    deal: clicked_deal,
                    search_id: this.state.search_token,
                    hotel: this.state.hotel,
                    user: this.state.profile,
                    suggest_alternative_flag: LazyRecheckStore.isSuggestAlternativeEnabled(),
                    alternatives_snapshot: LazyRecheckStore.getAlternativesSnapshot(),
                });
            } else {
                this._rateCheckPopupCount = Analytics.actions.responses.roomRateCheckPopupShown({
                    popup_type: 'changes_detected',
                    recheck_type: RECHECK_TYPE.LAZY,
                    price_changed: !!price_change_data.price_changed,
                    old_price: price_change_data.old_price,
                    new_price: price_change_data.new_price,
                    deadline_changed: !!price_change_data.deadline_changed,
                    board_changed: !!price_change_data.board_changed,
                    old_board: price_change_data.old_board,
                    new_board: price_change_data.new_board,
                    old_cancellation_deadline: price_change_data.old_cancellation_deadline,
                    new_cancellation_deadline: price_change_data.new_cancellation_deadline,
                    deal: navigation_deal,
                    search_id: this.state.search_token,
                    hotel: this.state.hotel,
                    user: this.state.profile,
                    suggest_alternative_flag: LazyRecheckStore.isSuggestAlternativeEnabled(),
                    alternatives_snapshot: LazyRecheckStore.getAlternativesSnapshot(),
                });
            }
        }

        this.setState({
            ...getHotelPageState(this.props.hotelId),
            lazy_recheck_busy: busy,
            lazy_recheck_price_change_data: price_change_data || null,
            lazy_recheck_no_availability: no_availability,
            lazy_recheck_dialog_open: dialog_will_open,
        });
    },

    _onLazyRecheckBack: function () {
        const price_change_data = this.state.lazy_recheck_price_change_data;
        const popup_type = this.state.lazy_recheck_no_availability ? 'rate_unavailable' : 'changes_detected';
        const original_terms = RecheckAlternative.buildOriginalTerms(LazyRecheckStore.getClickedDeal());
        Analytics.actions.responses.roomRateCheckPopupAction({
            action: 'back_to_hotel',
            popup_type,
            recheck_type: RECHECK_TYPE.LAZY,
            unavailable_reason: LazyRecheckStore.getUnavailableReason(),
            rejection_reason: LazyRecheckStore.getRejectedComparison()?.rejection_reason ?? null,
            price_changed: !!price_change_data?.price_changed,
            old_price: price_change_data?.old_price ?? original_terms.old_price,
            new_price: price_change_data?.new_price ?? null,
            deadline_changed: !!price_change_data?.deadline_changed,
            board_changed: !!price_change_data?.board_changed,
            old_board: price_change_data?.old_board ?? original_terms.old_board,
            new_board: price_change_data?.new_board ?? null,
            old_cancellation_deadline:
                price_change_data?.old_cancellation_deadline ?? original_terms.old_cancellation_deadline,
            new_cancellation_deadline: price_change_data?.new_cancellation_deadline ?? null,
            deal: LazyRecheckStore.getNavigationDeal() || LazyRecheckStore.getClickedDeal(),
            search_id: this.state.search_token,
            popup_exposure_count_in_search: this._rateCheckPopupCount ?? 1,
            hotel: this.state.hotel,
            suggest_alternative_flag: LazyRecheckStore.isSuggestAlternativeEnabled(),
            alternatives_snapshot: LazyRecheckStore.getAlternativesSnapshot(),
        });
        LazyRecheckActions.reset();
        this.setState({
            lazy_recheck_dialog_open: false,
            lazy_recheck_price_change_data: null,
            lazy_recheck_no_availability: false,
            lazy_recheck_busy: false,
        });
    },

    _onLazyRecheckConfirmPriceChange: function () {
        const price_change_data = this.state.lazy_recheck_price_change_data;
        if (price_change_data) {
            Analytics.actions.responses.roomRateCheckPopupAction({
                action: 'confirm',
                popup_type: 'changes_detected',
                recheck_type: RECHECK_TYPE.LAZY,
                price_changed: !!price_change_data.price_changed,
                old_price: price_change_data.old_price,
                new_price: price_change_data.new_price,
                deadline_changed: !!price_change_data.deadline_changed,
                board_changed: !!price_change_data.board_changed,
                old_board: price_change_data.old_board,
                new_board: price_change_data.new_board,
                old_cancellation_deadline: price_change_data.old_cancellation_deadline,
                new_cancellation_deadline: price_change_data.new_cancellation_deadline,
                deal: LazyRecheckStore.getNavigationDeal(),
                search_id: this.state.search_token,
                popup_exposure_count_in_search: this._rateCheckPopupCount ?? 1,
                hotel: this.state.hotel,
                suggest_alternative_flag: LazyRecheckStore.isSuggestAlternativeEnabled(),
                alternatives_snapshot: LazyRecheckStore.getAlternativesSnapshot(),
            });
        }
        LazyRecheckActions.confirmPriceChange();
    },
});

export default withTranslation()(HotelPage);
